import { render } from "./AlimtalkSendRequests.vue?vue&type=template&id=02ca51a8"
import script from "./AlimtalkSendRequests.vue?vue&type=script&lang=js"
export * from "./AlimtalkSendRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__